import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="题材导航"
          title="按类型，找到你的韩漫"
          desc="韩国漫画大全将内容按题材整理为三大核心专题，风格各不相同。点击进入对应专题，快速定位你偏好的类型。"
        />

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-md text-background-50 ${
                  c.accent === "primary"
                    ? "bg-primary-500"
                    : c.accent === "accent"
                    ? "bg-accent-500 text-foreground-950"
                    : "bg-secondary-500"
                }`}
              >
                <i className={`${c.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-1 text-sm font-medium text-primary-600">{c.tagline}</p>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{c.description}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-600">
                查看专题
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}